import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone'
import map from 'lodash/map'
import orderBy from 'lodash/orderBy';
import swal from "sweetalert2";

import { getClubs, editClub, postClub } from '../../../actions/app/mpt/clubs';

import './clubs.css'

class MptClubs extends React.Component {
    state = {
        input: '',
        image: null,
        clubList: null,
    };

    componentWillMount() {
        const { dispatch } = this.props;
        dispatch(getClubs());
    }

    onDrop(acceptedFiles, clubId) {
        const { dispatch } = this.props;
        const img = document.getElementById(`img${clubId}`);
        img.src = acceptedFiles[0].preview;
        dispatch(editClub({ clubId: clubId.split('_')[2], file: acceptedFiles[0] }))
    }

    onDropNewClub(acceptedFiles) {
        this.setState({ image: acceptedFiles[0] });
    }

    onBlur(clubId) {
        const clubName = document.getElementById(clubId).value;
        const { dispatch } = this.props;
        dispatch(editClub({ clubName, clubId: clubId.split('_')[2] }))
    }

    submitAddClub() {
        const { input, image } = this.state;
        const { dispatch } = this.props;
        input && image && dispatch(postClub({ clubName: input, file: image }))
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.clubs.info.error) {
            swal({
                title: `Oops...`,
                type: 'error',
                html: `Something went wrong, error: "${nextProps.clubs.info.error}" <br />Try again`
            });
        }
        this.setState({
            input: '',
            image: null,
        });
    }

    render() {
        const { clubs } = this.props;
        return (
            <div id="MptClubs">
                <header className="content-header">
                    <h1>
                        Dashboard
                        <small>Clubs</small>
                    </h1>
                    <ol className="breadcrumb">
                        {/*<li><i className="fa fa-trophy"/> MPP</li>*/}
                        <li className="text-bold"><Link to="/mpt">Dashboard</Link></li>
                    </ol>
                </header>
                <section className="content">
                    <div className="row">
                        <div id="players-list-widget" className="row">
                            <div className="col-md-12">
                                <div className="box box-default">
                                    <div className="box-header with-border">
                                        <h3 className="box-title pull-left">
                                            <i className="fa fa-address-card-o"/> Clubs list
                                        </h3>
                                        <table className="table table-responsive table-striped">
                                            <thead>
                                            <tr>
                                                <th>club name</th>
                                                <th>image</th>
                                                <th/>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <th>
                                                    <input
                                                        value={this.state.input}
                                                        onChange={
                                                            (text) => this.setState({ input: text.target.value })
                                                        }
                                                    />
                                                </th>
                                                <th>
                                                    <div className="grid">
                                                        {
                                                            this.state.image &&
                                                            <img
                                                                className="imageClub"
                                                                src={this.state.image.preview}
                                                                alt=""
                                                            />
                                                        }
                                                        <Dropzone
                                                            onDrop={(acceptedFiles) =>
                                                                this.onDropNewClub(acceptedFiles)
                                                            }
                                                            className="btn-warning dropzone"
                                                        >
                                                            Upload
                                                        </Dropzone>
                                                    </div>
                                                </th>
                                                <th>
                                                    <button
                                                        onClick={() => this.submitAddClub()}
                                                        className="btn-success"
                                                    >
                                                        Add club
                                                    </button>
                                                </th>
                                            </tr>
                                            </tbody>
                                        </table>
                                        {
                                            clubs.list &&
                                            <table className="table table-responsive table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Name</th>
                                                        <th>Image</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    map(orderBy(clubs.list, 'id', 'desc'), club => (
                                                        <tr key={club.id}>
                                                            <th className="text-center">{club.id}</th>
                                                            <th>
                                                                <input
                                                                    id={club.id}
                                                                    defaultValue={club.clubName}
                                                                    onBlur={() => this.onBlur(club.id)}
                                                                />
                                                            </th>
                                                            <th className="imgTh">
                                                                <div className="grid">
                                                                    <img
                                                                        id={`img${club.id}`}
                                                                        className="imageClub"
                                                                        src={club.imageUrl}
                                                                        alt=""
                                                                    />
                                                                    <Dropzone
                                                                        onDrop={(acceptedFiles) =>
                                                                            this.onDrop(acceptedFiles, club.id)
                                                                        }
                                                                        className="btn-warning dropzone"
                                                                    >
                                                                        Upload
                                                                    </Dropzone>
                                                                </div>
                                                            </th>
                                                          </tr>
                                                        )
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default connect(
    state => ({
        clubs: state.app.mpt.clubs,
    }),
    dispatch => ({ dispatch }),
)(MptClubs);



// WEBPACK FOOTER //
// ./src/pages/MPT/Clubs/index.js